import React, {useEffect, useState} from 'react';
import cx from 'classnames';
import './popup.scss';
import {TextInput} from '../../../components/crousal/TextInput';

// interface IProps {
//     errors?: Record<'name' | 'email', string>;
//     oldInput?: Record<'name' | 'email', string>;
// }

export function Popup() {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isPopupClosed, setClosePopup] = useState<boolean>(true);
    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');

    const [matches, setMatches] = useState(
        window.matchMedia('(min-width: 1680px)').matches
    );

    useEffect(() => {
        window
            .matchMedia('(min-width: 1680px)')
            .addEventListener('change', (e) => setMatches(e.matches));
        if (matches) {
            setIsOpen(true);
        }
    }, []);

    return (
        <React.Fragment>
            {isPopupClosed ? (
                <div
                    className={cx(
                        'popup-wrapper z-50 fixed w-full bottom-0 text-left flex items-center xxl_min:max-w-popupSize xxl_min:h-full xxl_min:z-1',
                        isOpen && 'open'
                    )}
                >
                    <div className="column mx-auto w-full">
                        <div
                            className={cx(
                                'popup-inner mx-auto w-full relative z-1 pt-16 pr-6 pb-0 pl-36 xxl_min:pt-32 xxl_min:pr-12 xxl_min:pl-8 lg_max:pb-4 lg_max:px-4 ',
                                isOpen ? 'pb-4 lg_max:pt-4' : 'lg_max:pt-16'
                            )}
                        >
                            <div
                                className="popup-close cursor-pointer w-12 h-12 absolute rounded-full flex items-center justify-center z-30"
                                onClick={() => {
                                    if (isOpen === true && !matches) {
                                        setClosePopup(true);
                                        setIsOpen(false);
                                    } else {
                                        setClosePopup(false);
                                        setIsOpen(false);
                                    }
                                }}
                            >
                                <img
                                    src={"/images/unrankedsmurfs-login/popup-close.svg"}
                                    alt="popup-close"
                                    className="z-10"
                                />
                                <img
                                    src={"/images/unrankedsmurfs-login/popup-close-bg.svg"}
                                    alt="popup-close-bg"
                                    className="absolute z-0"
                                />
                            </div>

                            <div className="xxl_max:flex flex-wrap w-full">
                                <div
                                    className={cx(
                                        'about-smurfing w-1/3 xxl_min:w-full lg_max:w-full',
                                        isOpen ? 'lg_max:flex' : ''
                                    )}
                                >
                                    <div
                                        className={cx(
                                            'about-img pr-6 flex items-center xxl_max:justify-center max-w-xxs w-full xxl_min:h-auto xxl_min:w-full xxl_max:absolute',
                                            isOpen
                                                ? 'lg_min:h-full lg_max:pr-0 lg_max:relative'
                                                : ''
                                        )}
                                    >
                                        <img
                                            src={"/images/unrankedsmurfs-login/diana.png"}
                                            alt="popup-img"
                                            className={cx(
                                                'w-32 xxl_min:w-24 lg_max:max-w-120px',
                                                isOpen
                                                    ? 'lg_max:pb-0'
                                                    : 'lg_max:pb-8'
                                            )}
                                        />
                                    </div>
                                    <div
                                        className={cx(
                                            'about-text',
                                            isOpen
                                                ? 'lg_max:text-left lg_max:text-left lg_max:pt-4 lg_max:pl-4'
                                                : 'lg_max:text-center'
                                        )}
                                    >
                                        <p
                                            className={cx(
                                                'text-almost-black text-md m-0 text-almost-black pt-4 xxl_min:pt-0 lg_max:pt-0 lg_max:pb-0',
                                                isOpen
                                                    ? 'leading-md font-semibold w-32 '
                                                    : 'lg_max:w-full'
                                            )}
                                        >
                                            Are you thinking about smurfing?
                                        </p>
                                        {isOpen ? (
                                            <small className="block lg:text-xs leading-md mt-3">
                                                Unranked Smurfs is more than
                                                just an account selling website.
                                                We also produce hight quality
                                                content for our subscribers.
                                            </small>
                                        ) : null}
                                    </div>
                                </div>
                                <div
                                    className="popup-opener lg:w-1/5 px-3 text-center cursor-pointer xxl_min:d-none lg_max:w-full lg_max:text-center">
                                    {!isOpen && (
                                        <div
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                            <img
                                                src={"/images/unrankedsmurfs-login/popup-opener.svg"}
                                                alt="popup-opener"
                                            />
                                        </div>
                                    )}
                                </div>
                                <div
                                    className={cx(
                                        'signup-block w-2/5 my-4 xxl_min:w-full lg_max:my-0 lg_max:w-full lg_max:w-full',
                                        isOpen
                                            ? ' xxl_max:pt-3 lg_max:text-left'
                                            : 'lg_max:text-center'
                                    )}
                                >
                                    <p className="text-almost-black text-md leading-md mb-3 lg_max:pt-0 lg_max:pb-0">
                                        Signup,{' '}
                                        <a
                                            href="#"
                                            className="text-winter-blue hover:text-almost-black font-semibold"
                                        >
                                            get guides{' '}
                                        </a>{' '}
                                        and{' '}
                                        <a
                                            href="#"
                                            className="text-winter-blue hover:text-almost-black font-semibold"
                                        >
                                            {' '}
                                            win rewards
                                        </a>
                                    </p>
                                    {isOpen ? (
                                        <ul className="list-disc pl-4 pl-1 list-none  text-xs">
                                            <li className="flex items-center">
                                                <span className="leading-md">
                                                    <a
                                                        href="#"
                                                        className="text-winter-blue hover:text-almost-black font-semibold"
                                                    >
                                                        How to reach Diamond in
                                                        LoL E-Book
                                                    </a>{' '}
                                                    - Written by our Challenger
                                                    coach.
                                                </span>
                                            </li>
                                            <li className="flex items-center">
                                                3 Fastest ways to level up your
                                                account
                                            </li>
                                        </ul>
                                    ) : null}
                                </div>
                                {isOpen ? (
                                    <React.Fragment>
                                        <form
                                            className={cx(
                                                'mt-4 w-full xxl_max:flex lg_max:block'
                                            )}
                                        >
                                            <div
                                                className={cx(
                                                    'w-1/3 mr-4 xxl_min:w-full xxl_min:mb-4 lg_max:w-full lg_max:mb-4'
                                                )}
                                            >
                                                <TextInput
                                                    label="Your Name"
                                                    value={name}
                                                    onChange={setName}
                                                    // onEnter={handleSignup}
                                                    placeholder={'Name'}
                                                    // Shows an error state in the input, but not the actual message.
                                                    // The message is shown for the second field.
                                                    // error={
                                                    //     errors.name ? '' : undefined
                                                    // }
                                                />
                                            </div>
                                            <div
                                                className={cx(
                                                    'w-1/3 mr-4 xxl_min:w-full xxl_min:mb-4 lg_max:w-full lg_max:mb-4'
                                                )}
                                            >
                                                <TextInput
                                                    label="Your Email"
                                                    value={email}
                                                    onChange={setEmail}
                                                    placeholder={'Email'}
                                                    // Shows an error state in the input, but not the actual message.
                                                    // The message is shown for the second field.
                                                    // error={
                                                    //     errors.email
                                                    //         ? ''
                                                    //         : undefined
                                                    // }
                                                />
                                            </div>
                                            <div className="flex items-end">
                                                <button
                                                    type="button"
                                                    className="py-4 px-8 bg-absolute-white color-almost-black border-0 outline-0 text-sm lg_max:text-sm lg_max:py-3 lg_max:px-10"
                                                >
                                                    Sign Up{' '}
                                                    <i className="arrow inline-block p-1 border-r border-b border-t-0 border-l-0 rotate-45"></i>
                                                </button>
                                            </div>
                                        </form>
                                        <p className="text-almost-black lg:text-sm text-sm leading-sm mt-4 w-full 2xl:text-center text-left lg_max:pt-0 lg_max:pb-0">
                                            Your get regular relevant{' '}
                                            <a
                                                href="#"
                                                className="text-winter-blue hover:text-almost-black font-semibold"
                                            >
                                                content every month
                                            </a>{' '}
                                            +{' '}
                                            <a
                                                href="#"
                                                className="text-winter-blue hover:text-almost-black font-semibold"
                                            >
                                                free entry to our giveaways.
                                            </a>{' '}
                                            Win free accounts and RP
                                        </p>
                                    </React.Fragment>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
}
